/* eslint-disable eqeqeq */
/* eslint-disable use-isnan */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import PropTypes from 'prop-types';

import { ModalBody, ModalFooter } from '@vds/modals';
import { Title } from '@vds/typography';

import Button from '../../common/Button';
import { FWAContainer, Col, Row } from '../../common/FWAContainer';
import MiniCart from '../../common/MiniCart/redesign';
import { store } from '../../../configureStore';
import {
  isMobile,
  isTablet,
  getSession,
  getAPPID,
  viewport,
  isDesktopResolution,
  scrollToTop,
  isLoggedIn,
  pdcAEMCheck,
  isFuncComp,
  renderHTML,
  isExpressCheckout,
} from '../../common/Helpers/index';
import '../../../assets/css/pages/payments/payment.css';
import { eventDispatcher, updateCSTaggingPageDetail, updateUrl } from '../../common/Tagging/index';
import Notification from '../../common/Notification/redesign/index';
import VideoChat from '../../common/VideoChat/redesign/index';
import ChatAndC2C from '../../common/ChatAndC2C';
import { checkCartidAndLQResponse } from '../../common/Helpers/commonLog';

import { VDSModal as Modal } from '../../common/Modal/VDSModal';

import { Margin, StyledVdsCol, StyledVdsRow } from '../../common/styles';
import { callPerformanceMeasure } from '../../common/Helpers/performanceMeasure';
import { notificationProps } from './PaymentCommon';
import { saveItemToStore } from '../../../utils/sessionStorage';
import DesktopCart from '../../NextGen/OrderSummary/DesktopCart';
// import StickyCart from '../../NextGen/OrderSummary/StickyCart';

export default class PaymentTemplate extends Container {
  constructor(props) {
    super(props);
    this.isTablet = isTablet();
    this.isMobile = isMobile();
    checkCartidAndLQResponse('Payment');
  }

  componentDidMount() {
    // paymentCommonMethod(this);
    document.title = 'Verizon Wireless';
    saveItemToStore('ccAttempts', 0);
    updateUrl();
    const btn = document.getElementById('refSecDep');
    if (btn) {
      btn.addEventListener('click', this.modalrefundableOpen);
    }
    this.setState({ modalOpened: false });
    const data = {
      pageName: 'payment',
    };
    if (!isLoggedIn() && pdcAEMCheck()) {
      this.props.updatePdc(data);
    }

    if (!getSession('paypalAuthFailed')) {
      store.dispatch({ type: 'CEF_PAYMENT_INFO_ERROR', response: false, errorMessage: null });
    }
    store.dispatch({ type: 'UPDATE_API_STATUS', response: 'IN_PROGRESS' });
    store.dispatch({ type: 'TAGGING_API_LOADED', response: false });
  }

  updateTaggingInfoMessage = (taggingMessage) => {
    if (!this.state.fwaSDTagging && this.props.sessionValues?.taggingApiLoaded && window.vzdl?.page?.name === 'getCustomerPaymentInfo') {
      updateCSTaggingPageDetail('credit status pass - security deposit');
      eventDispatcher('sendData', {
        name: '',
        svars: {
          evar13: taggingMessage || '',
          evar22: 'message displayed',
        },
      });
      this.setState({ fwaSDTagging: true });
    }
  };

  componentDidUpdate() {
    if (!this.state.invokeTagging && this.props.cartDetails?.apiStatus === 'COMPLETED' && this.props.apiLoaded) {
      this.props.invokeTaggingAPI();
      store.dispatch({ type: 'API_LOADED', response: false });
      this.setState({ invokeTagging: true });
    }
    if (this.props.sessionValues?.taggingApiLoaded && window.vzdl?.page?.name === 'getCustomerPaymentInfo') {
      const { cartDetails } = this.props;
      const downPaymentAmt = this.props.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.downPaymentAmount || 0;
      let fwaSecurityDeposit = this.props.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.fwaSecurityDepositAmount;
      fwaSecurityDeposit = fwaSecurityDeposit !== undefined && fwaSecurityDeposit !== null && fwaSecurityDeposit !== '' ? fwaSecurityDeposit : 0;
      if (
        getAPPID() === 'NSE' &&
        cartDetails?.cartDetailsJson?.orderDetailsView?.dueTodayAmount > 0 &&
        (Number.isNaN(parseFloat(fwaSecurityDeposit)) || parseFloat(fwaSecurityDeposit) === 0) &&
        downPaymentAmt === 0
      ) {
        updateCSTaggingPageDetail('credit status pass');
      }
      store.dispatch({ type: 'TAGGING_API_LOADED', response: false });
    }
    if (document.readyState === 'complete') {
      callPerformanceMeasure();
    }
    if (this.props.paymentError || this.props.showError || this.props.isPostPaymentPaypalError || this.props.showPaymentApiError) {
      scrollToTop();
    }
  }

  modalrefundableOpen = () => {
    this.setState({ modalOpened: true });
  };

  modalChanged = (state) => {
    this.setState({ modalOpened: state });
  };

  Continue = (e) => {
    e.preventDefault();
    this.setState({ modalOpened: false });
  };

  getSDMsgStatus = () => {
    if (!this.state.isSDStatus && this.props.sessionValues?.taggingApiLoaded && window.vzdl?.page?.name === 'getCustomerPaymentInfo') {
      this.setState({ isSDStatus: true });
      let { notificationTitle = '' } = this.props;
      notificationTitle = notificationTitle.replace('XXXX', getSession('FlowType'));
      eventDispatcher('sendData', {
        name: '',
        svars: {
          evar13: notificationTitle || '',
          evar22: 'message displayed',
        },
      });
    }
  };

  render() {
    const {
      cartDetails,
      refundableModalHeader,
      refundableModalBody,
      notifyMessage = 'The Shipping Address that you selected from your PayPal Address Book is invalid. Please return to PayPal and update your shipping address or select another form of payment.',
    } = this.props;

    const ctaMarkers = ['ccCardCTA', 'payPalCTA'];
    const paymentComponents = this.childComponents.filter(
      (item) =>
        !(
          item.key.indexOf('/miniCartDueToday') >= 0 ||
          item.key.indexOf('/miniCartDueMonthly') >= 0 ||
          item.key.indexOf('/miniCartFunctionalDueToday') >= 0 ||
          item.key.indexOf('/miniCartFunctionalDueMonthly') >= 0
        ),
    );
    const miniCartComponents = this.childComponents.filter(
      (item) => item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0,
    );
    const miniCartComponentsFunc = this.childComponents.filter(
      (item) => item.key.indexOf('/miniCartFunctionalDueToday') >= 0 || item.key.indexOf('/miniCartFunctionalDueMonthly') >= 0,
    );

    const miniCartRef = isFuncComp() ? miniCartComponentsFunc : miniCartComponents;

    const flowType = getSession('FlowType');
    let showCreditMsg = false;
    const downPaymentAmt = this.props.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.downPaymentAmount || 0;
    let fwaSecurityDeposit = this.props.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.fwaSecurityDepositAmount;
    fwaSecurityDeposit = fwaSecurityDeposit !== undefined && fwaSecurityDeposit !== null && fwaSecurityDeposit !== '' ? fwaSecurityDeposit : 0;

    if (
      getAPPID() === 'NSE' &&
      cartDetails?.cartDetailsJson?.orderDetailsView?.dueTodayAmount > 0 &&
      (Number.isNaN(parseFloat(fwaSecurityDeposit)) || parseFloat(fwaSecurityDeposit) === 0) &&
      downPaymentAmt === 0
    ) {
      showCreditMsg = true;
      this.getSDMsgStatus();
    }
    const notificationHead = renderHTML(
      "<p>Looks like a transaction was started on another device. Start a new transaction to continue.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a class='transactionLink' onClick='window.redirectToHomePage()'> Start new order</a></p>",
    );
    const type = viewport();
    const notificationDetails = notificationProps(this.props, showCreditMsg, this.updateTaggingInfoMessage, notifyMessage, notificationHead);
    return (
      <>
        <Notification {...notificationDetails} />
        <FWAContainer topBufferAuto>
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }} className="textAlignRight displayInlineFlex">
              {!(isMobile() || isTablet()) && (
                <>
                  {flowType === '5G' && <VideoChat title={this.props.title} />}
                  <ChatAndC2C type={type} />
                </>
              )}
            </Col>
          </Row>
          <StyledVdsRow className="paymentWrapper" mTop={isMobile() || isTablet() ? '56px' : '45px'} pLeft={!isMobile() && !isTablet() && '0px'}>
            <StyledVdsCol colSizes={{ mobile: 4, tablet: 9, desktop: 8 }}>
              {this.state.modalOpened && (
                <Modal ariaLabel="Refundable deposit info" opened={this.state.modalOpened} onOpenedChange={this.modalChanged}>
                  <ModalBody>
                    <Margin bottom="20px">
                      <Title size="medium" bold color="#000000">
                        {refundableModalHeader}
                      </Title>
                    </Margin>
                    <span dangerouslySetInnerHTML={{ __html: refundableModalBody }} />
                  </ModalBody>
                  <ModalFooter>
                    {isMobile() && (
                      <Button width="100%" onClick={this.Continue}>
                        Close
                      </Button>
                    )}
                  </ModalFooter>
                </Modal>
              )}

              {paymentComponents}
            </StyledVdsCol>
            <StyledVdsCol colSizes={{ mobile: 0, tablet: 0, desktop: 4 }}>
            {/* {!isDesktopResolution() && isExpressCheckout() && <StickyCart btnName="Review Order" callBtnMethod={this.onClickButton} /> }               */}
            {isDesktopResolution() && (
                <Margin top="180px" left={!isMobile() && '10px'}>
                  <div className="widthFitContent">
                    { isExpressCheckout() && <DesktopCart />}
                    {!isExpressCheckout() && (
                      <MiniCart
                        miniCartComponents={miniCartRef}
                        showCartStatus={(iscartVisibleVal) => this.props.showCart(iscartVisibleVal)}
                        iscartVisible={this.props.cartDetails.isCartVisible}
                      />
                    )}
                    {ctaMarkers.map((markerId) => (
                      <div id={markerId} />
                    ))}
                  </div>
                </Margin>
              )}
            </StyledVdsCol>
          </StyledVdsRow>
        </FWAContainer>
      </>
    );
  }
}

PaymentTemplate.propTypes = {
  newtitle: PropTypes.string,
  invokeTaggingAPI: PropTypes.func,
};
